import React from "react";

import styles from "./Hero.module.scss";

export const Hero = function ({ scrollTo }) {
  return (
    <section id="form" className={styles.hero}>
      <div className={styles.heroContainer}>
        <h1>ARTIFICIAL INTELLIGENCE IN PHARMA AND BIOTECH</h1>
        <small>ONLINE SHORT COURSE</small>
        <p>Bridge the gap between innovative technology, drug development, and business decision making.</p>
        <button onClick={scrollTo} id="cta-scroll">
          GET MORE INFORMATION
        </button>
      </div>
    </section>
  );
};
